import React, { useState } from "react";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowPlane } from "../../../assets/images/signUp/arrowplane.svg";
import { ReactComponent as Switch } from "../../../assets/images/signUp/switch.svg";
import { ReactComponent as RadioSearch } from "../../../assets/images/signUp/radiosearch.svg";
import { ReactComponent as MapPad } from "../../../assets/images/signUp/man-with-pad.svg";
import Logo from "../Logo";
import { SideSVG } from "../../common";
import ReactGA from "react-ga4";

const PlatformOptions = ({ onNext }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState(false);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleNext = (e) => {
    ReactGA.event({
      category: 'Platform Option',
      action: 'Select Platform option',
      label:`Selected Option is ${selectedOption}`,
    });
    e.preventDefault();
    if (selectedOption === "") {
      setError(true);
      return;
    }
    
    onNext(selectedOption);
  };

  return (
    <section className="relative py-20 sm:py-0 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo classes="max-w-md lg:py-5 mx-auto absolute top-[-3.75rem] left-1/2 transform -translate-x-1/2 sm:left-[7rem] sm:top-5 sm:z-10" />
          <div className="flex flex-wrap px-4 -mx-4 xl:items-center items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md lg:py-20 mx-auto ">
                <h3 className="font-heading text-f24 sm:text-h3 text-primary font-semibold mb-4 text-center">
                  What brings you here?
                </h3>
                <div className="flex flex-col gap-2 mb-10 ">
                  <div className=" flex flex-col gap-2">
                    <label
                      className={`bg-inputDisable border-2 border-input rounded-md inline-flex items-center justify-start gap-4  w-full p-5 text-gray-500 cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100  ${selectedOption === "explore"
                          ? "border-2 border-primary shadow-md"
                          : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="option"
                        value="explore"
                        checked={selectedOption === "explore"}
                        onChange={handleOptionChange}
                        className="form-radio text-blue-500 hidden peer"
                      />
                      <ArrowPlane />
                      <div className="block text-left">
                        <span className="text-primary text-f16">
                          Explore Platform
                        </span>
                        <span className="text-secondary text-f12 block">
                          Get company details, follow company & many more
                        </span>
                      </div>
                    </label>
                    <label
                      className={`bg-inputDisable border-2 border-input rounded-md inline-flex items-center justify-start gap-4  w-full p-5 text-gray-500 cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100  ${selectedOption === "manage"
                          ? "border-2 border-primary shadow-md"
                          : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="option"
                        value="manage"
                        checked={selectedOption === "manage"}
                        onChange={handleOptionChange}
                        className="form-radio text-blue-500 hidden peer"
                      />
                      <Switch />
                      <div className="block text-left">
                        <span className="text-primary text-f16">
                          Manage Companies
                        </span>
                        <span className="text-secondary text-f12 block">
                          Register Your Company on our platform and get verified
                        </span>
                      </div>
                    </label>
                    <label
                      className={`bg-inputDisable border-2 border-input rounded-md inline-flex items-center justify-start gap-4  w-full p-5 text-gray-500 cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100  ${selectedOption === "search"
                          ? "border-2 border-primary shadow-md"
                          : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="option"
                        value="search"
                        checked={selectedOption === "search"}
                        onChange={handleOptionChange}
                        className="form-radio text-blue-500 hidden peer"
                      />
                      <RadioSearch />
                      <div className="block text-left">
                        <span className="text-primary text-f16">
                          Search Company
                        </span>
                        <span className="text-secondary text-f12 block">
                          Search from thousands of company registered on TREVEX
                        </span>
                      </div>
                    </label>
                  </div>
                  {error && (
                    <div className="text-red-500 text-sm text-left pt-2">
                      Please select one option.
                    </div>
                  )}
                </div>

                <button
                  className={`relative group w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center mr-2 gap-4 `}
                  onClick={handleNext}
                >
                  <span className="relative">{"Next"}</span>
                  <ArrowRight />
                </button>
              </div>
            </div>

            <SideSVG SVG={MapPad} positions="bottom-0  left-[-25%]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformOptions;
